import { NSARouterMakerResult } from "namirasoft-account-react";
import { SMSSenderLayout } from "../SMSSenderLayout";
import { SMSSenderProps } from "../SMSSenderProps";
import { SMSSenderEntities } from "../SMSSenderEntities";

interface ProviderViewPageProps extends NSARouterMakerResult, SMSSenderProps
{ }

export default function ProviderViewPage(props: ProviderViewPageProps)
{
	return (
		<SMSSenderLayout
			{...props}
			action={{
				title: "",
				description: "This section displays detailed information about a selected SMS provider.",
				menus: {}
			}}
			pages={{
				entity: SMSSenderEntities.provider(props),
				view: {}
			}}
		>
			<> </>
		</SMSSenderLayout>
	);
}